module.exports = __webpack_public_path__ + "img/food-6.372abab3.jpg";